import { SystemPreferences } from "../common/system-preferences";
// import { wafFormConfig } from "./waf-form-config";

export const systemPreferencesInternalConfig = {} as SystemPreferences;

export function updateSystemPreferencesInternalConfig(obj: any) {
    if (obj && typeof obj === 'object') {
        Object.assign(systemPreferencesInternalConfig, obj);
    }
}